import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "2-state-05-square",
  "use": "2-state-05-square-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"2-state-05-square\">\n  <path d=\"M62 62h900v900h-900v-900z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol